import { ModelOptions } from './model-options';

export class TreeViewModelOptions extends ModelOptions {
    public readonly maxSelections: number;
    public readonly dragndrop: boolean;
    public readonly required: boolean;
    public constructor(
        {
            maxSelections = 1,
            dragndrop = false,
            required = false,
        }: {
            maxSelections?: number;
            dragndrop?: boolean;
            required?: boolean;
        } = {
            maxSelections: 1,
            dragndrop: false,
            required: false,
        },
    ) {
        super();
        this.maxSelections = maxSelections;
        this.dragndrop = dragndrop;
        this.required = required;
    }
}

export class TreeViewModelOptionsFromJson extends TreeViewModelOptions {
    public constructor(data: JsonTreeViewModelOptions) {
        super({
            maxSelections: data.maxSelections ? data.maxSelections : 1,
            dragndrop: data.dragndrop,
            required: data.required,
        });
    }
}

export interface JsonTreeViewModelOptions {
    maxSelections: number;
    dragndrop: boolean;
    required: boolean;
}
